import {
	Card,
	DatePicker,
	Form,
	Select,
	Space,
	Tabs,
	Typography,
	Button,
} from "antd";
import { useTable } from "@refinedev/antd";
import { useEffect, useState } from "react";
import UserSearchSelect from "../../components/UserSearchSelect";
import { FilterOutlined } from "@ant-design/icons";
import { ReportReviewList } from "../components/ReportReviewList";

const { RangePicker } = DatePicker;
const { Title } = Typography;

export const ReportUserList = () => {
	const [activeTab, setActiveTab] = useState("pending");

	const { tableProps, searchFormProps, setFilters } = useTable({
		onSearch: (values: any) => {
			return [
				{
					field: "entityType",
					operator: "eq",
					value: "stream:user",
				},
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
				{
					field: "reporterType",
					operator: "eq",
					value: values.reporterType,
				},
				{
					field: "from",
					operator: "eq",
					value: values.dateRange
						? values.dateRange[0].startOf("day").toISOString()
						: undefined,
				},
				{
					field: "to",
					operator: "eq",
					value: values.dateRange
						? values.dateRange[1].startOf("day").toISOString()
						: undefined,
				},
				{
					field: "reason",
					operator: "eq",
					value: values.userReportReason,
				},
				{
					field: "reporterID",
					operator: "eq",
					value: values.reporterID,
				},
				{
					field: "entityCreatorID",
					operator: "eq",
					value: values.entityCreatorID,
				},
			];
		},
		syncWithLocation: true,
		filters: {
			initial: [
				{
					field: "entityType",
					operator: "eq",
					value: "stream:user",
				},
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
			],
		},
		queryOptions: {
			keepPreviousData: false,
			cacheTime: 0, // Changed to milliseconds
		},
		resource: "report",
	});

	useEffect(() => {
		activeTab === "pending" &&
			setFilters([
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
			]);
		activeTab === "reviewed" &&
			setFilters([
				{
					field: "isReviewed",
					operator: "eq",
					value: "true",
				},
			]);
	}, [activeTab]);

	return (
		<div style={{ padding: "20px" }}>
			<Title level={3}>User Reports Management</Title>
			<div style={{ padding: "20px" }}>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: 24,
						marginTop: "20px",
					}}
				>
					<Card style={{ width: 300 }}>
						<Title level={3}>Filter user reports</Title>
						<hr
							style={{
								marginLeft: -25,
								border: "0.2px solid #424242",
								width: 300,
							}}
						/>
						<Form
							{...searchFormProps}
							layout="vertical"
							style={{ marginTop: 20 }}
						>
							<Form.Item name="entityCreatorID" label="User">
								<UserSearchSelect
									onChange={(value: any) =>
										searchFormProps.form?.setFieldValue(
											"entityCreatorID",
											value,
										)
									}
									userType={
										searchFormProps.form?.getFieldValue("userType") || []
									}
								/>
							</Form.Item>
							<Form.Item name="reporterID" label="Reporter">
								<UserSearchSelect
									onChange={(value: any) =>
										searchFormProps.form?.setFieldValue("reporterID", value)
									}
									userType={
										searchFormProps.form?.getFieldValue("userType") || []
									}
								/>
							</Form.Item>
							<Form.Item name="userReportReason" label="Reason">
								<Select
									placeholder="Select reason"
									allowClear
									options={[
										{ value: "blood", label: "Blood" },
										{ value: "bully", label: "Bullying" },
										{
											value: "child exploitation",
											label: "Child Exploitation",
										},
										{ value: "gun", label: "Gun" },
										{ value: "harassment", label: "Harrasment" },
										{ value: "hate", label: "Hate Speech" },
										{ value: "impoersionation", label: "Impersionation" },
										{ value: "inappropriate", label: "Inappropriate" },
										{ value: "misinformation", label: "Misinformation" },
										{ value: "nudity/sexual", label: "Nudity/Sexual Content" },
										{ value: "offensive", label: "Offensive Content" },
										{ value: "scam", label: "Scam" },
										{ value: "spam", label: "Spam" },
										{ valule: "suggestive", label: "Suggestive" },
										{ value: "troll", label: "Trolling" },
										{
											value: "violence/terrorism",
											label: "Violence/Terrorism",
										},
										{ value: "other", label: "Other Reason" },
									]}
								/>
							</Form.Item>
							<Form.Item name="dateRange" label="Date">
								<RangePicker />
							</Form.Item>
							<Space style={{ display: "flex", justifyContent: "flex-end" }}>
								<Form.Item>
									<Button
										type="primary"
										icon={<FilterOutlined />}
										htmlType="submit"
									>
										Search
									</Button>
								</Form.Item>
							</Space>
						</Form>
					</Card>

					<div style={{ flex: 1 }}>
						<Tabs
							activeKey={activeTab}
							onChange={setActiveTab}
							type="card"
							destroyInactiveTabPane={true}
							items={[
								{
									key: "pending",
									label: "Pending Reports",
									children: <ReportReviewList tableProps={tableProps}
                                    actionButtonsToShow={{
                                        markAsReviewed: true,
                                        globalBan: true,
                                        globalBan24H: true,
                                        unBan: true,
                                    }}/>,
								},
								{
									key: "reviewed",
									label: "Reviewed Reports",
									children: (
										<ReportReviewList
											tableProps={tableProps}
											showReviewdBy={true}
                                            actionButtonsToShow={{
                                                globalBan: true,
                                                globalBan24H: true,
                                                unBan: true,
                                            }}/>
									),
								},
							]}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
